import { z } from "zod";

import http from "@/services/http";

const marketingTextOptions = z
  .object({
    id: z.number(),
    marketing_code: z.string(),
    last_updated_by: z.string(),
    marketing_text: z.string(),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
    deleted_at: z.string().datetime().nullish(),
  })
  .passthrough();

const marketingCardOptions = z
  .object({
    alignment: z.string(),
    bg_color: z.string(),
    card_color: z.string(),
    created_at: z.string().datetime(),
    deleted_at: z.string().datetime().nullish(),
    id: z.number(),
    image_url: z.string(),
    last_updated_by: z.string(),
    link: z.string(),
    marketing_code: z.string(),
    target: z.boolean().nullable(),
    text_color: z.string(),
    updated_at: z.string().datetime(),
  })
  .passthrough();

const marqueeResponse = z
  .object({
    data: z.object({
      marketing_card_options: z.array(marketingCardOptions),
      marketing_text_options: z.array(marketingTextOptions),
    }),
  })
  .strict();

const marquee = z
  .object({
    marketing_card_options: marketingCardOptions,
    marketing_text_options: z.array(marketingTextOptions),
  })
  .strict();

export type MarqueeResponseResult = z.infer<typeof marqueeResponse>;

export type Marquee = z.infer<typeof marquee>;

export async function fetch() {
  const { data } = await http().get(
    `${globalThis.env.API_MARKETING}/marketing-info/current`
  );

  return marqueeResponse.parse(data);
}
const cardElement = z
  .object({
    id: z.number(),
    marketing_code: z.string().nullish(),
    marketing_text: z.string().nullish(),
    text: z.string().nullish(),
    target: z.boolean().nullish(),
    type: z.string().nullish(),
    action: z.string().nullish(),
    link: z.string().nullish(),
    color: z.string().nullish(),
    hidden: z.unknown().nullish(),
  })
  .passthrough();

const pricingInfo = z
  .object({
    productGuid: z.number(),
    clc_count: z.number(),
    name: z.string(),
    guid: z.string(),
    discount: z.number(),
    discount_price: z.number(),
    price: z.number(),
  })
  .nullish();

export const featuredCardData = z.object({
  alignment: z.string().nullish(),
  bg_color: z.string().nullish(),
  card_color: z.string().nullish(),
  id: z.number(),
  image_url: z.string().nullish(),
  product_id: z.number().nullish(),
  link: z.string().nullish(),
  marketing_code: z.string(),
  target: z.boolean().nullable(),
  text_color: z.string().nullish(),
  marketing_card_elements: z.array(cardElement).nullish(),
  pricing_info: pricingInfo,
});

export type MarketingCard = z.infer<typeof cardElement>;
export type FeaturedCardTypes = z.infer<typeof featuredCardData>;

const featureOptions = z
  .object({
    data: z.array(featuredCardData),
  })
  .strict();

export async function marketingInfo() {
  const { data } = await http().get(
    `${globalThis.env.API_MARKETING}/marketing-info/current/v2`
  );
  return featureOptions.parse(data);
}
